import Fuse from 'fuse.js'
import { minimumLength } from '../components/common/search-bar/SearchBar'
import { type AdminCompany } from '../redux/admin/admin-companies-types'

export function sortCompanies(companies?: AdminCompany[]): AdminCompany[] {
  if (companies == null || companies.length === 0) {
    return []
  }

  return companies.sort((a, b) => {
    const aName = a.name.toUpperCase()
    const bName = b.name.toUpperCase()
    return aName.localeCompare(bName)
  })
}

const searchCompaniesFuseOptions = {
  keys: ['name'],
  includeScore: true,
  minMatchCharLength: minimumLength
}

export function searchCompanies(companies: AdminCompany[], searchText: string): AdminCompany[] {
  if (companies.length === 0) {
    return []
  }

  if (searchText.length > 2) {
    companies = new Fuse(companies, searchCompaniesFuseOptions).search(searchText).map(e => e.item)
    return companies
  }
  return companies
}
